(() => {
  const overlay = document.querySelector('[data-page-transition]');

  if (!overlay) return;

  const minimumEntryDuration = 1000;
  const maximumEntryDuration = 2500;
  const internalNavigationDelay = 700;
  let fallbackTimer;
  let transitionDelayTimer;
  let entryTimer;
  let maximumEntryTimer;

  const hideOverlay = () => {
    window.clearTimeout(fallbackTimer);
    window.clearTimeout(transitionDelayTimer);
    window.clearTimeout(entryTimer);
    window.clearTimeout(maximumEntryTimer);
    document.documentElement.classList.remove('novel-first-visit');
    overlay.classList.remove('is-active');
  };

  const showOverlay = () => {
    overlay.classList.add('is-active');
    fallbackTimer = window.setTimeout(hideOverlay, 6000);
  };

  const finishInitialEntry = () => {
    const startedAt = window.__novelIntroStartedAt || Date.now();
    const elapsed = Date.now() - startedAt;
    const remaining = Math.max(0, minimumEntryDuration - elapsed);

    entryTimer = window.setTimeout(hideOverlay, remaining);
  };

  const isInitialEntry = document.documentElement.classList.contains('novel-first-visit');

  if (window.Shopify && window.Shopify.designMode) {
    hideOverlay();
  } else if (isInitialEntry) {
    overlay.classList.add('is-active');
    maximumEntryTimer = window.setTimeout(hideOverlay, maximumEntryDuration);

    if (document.readyState === 'complete') {
      finishInitialEntry();
    } else {
      window.addEventListener('load', finishInitialEntry, { once: true });
    }
  }

  const isModifiedClick = (event) => {
    return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
  };

  document.addEventListener('click', (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      isModifiedClick(event) ||
      !(event.target instanceof Element) ||
      (window.Shopify && window.Shopify.designMode)
    ) {
      return;
    }

    const link = event.target.closest('a[href]');

    if (
      !link ||
      link.hasAttribute('download') ||
      link.hasAttribute('data-no-page-transition')
    ) {
      return;
    }

    const target = (link.getAttribute('target') || '').toLowerCase();
    const href = (link.getAttribute('href') || '').trim();

    if ((target && target !== '_self') || !href || href.startsWith('#')) {
      return;
    }

    let destination;

    try {
      destination = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }

    if (
      !['http:', 'https:'].includes(destination.protocol) ||
      destination.origin !== window.location.origin
    ) {
      return;
    }

    const current = new URL(window.location.href);
    const isSameDocumentAnchor =
      destination.pathname === current.pathname &&
      destination.search === current.search &&
      destination.hash;

    if (destination.href === current.href || isSameDocumentAnchor) {
      return;
    }

    window.clearTimeout(transitionDelayTimer);
    transitionDelayTimer = window.setTimeout(showOverlay, internalNavigationDelay);
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      hideOverlay();
    }
  });
})();
